import { UpperCasePipe } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';

import { SearchModel } from '@models/search';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ItvDatePipe } from '@shared/pipes/itv-date.pipe';
import { HighlightTextPipe } from '@shared/pipes/string-pipes/highlight-text.pipe';
import { TruncateTextPipe } from '@shared/pipes/string-pipes/truncate-text.pipe';
import { DocumentService } from '@shared/services/document.service';
import { SearchStore } from '@system/search/store';

@Component({
  selector: 'cipo-search-result-card',
  templateUrl: './search-result-card.component.html',
  styleUrls: ['./search-result-card.component.scss'],
  imports: [
    MatCard,
    MatCardContent,
    MatCardHeader,
    TranslateModule,
    ItvDatePipe,
    UpperCasePipe,
    HighlightTextPipe,
    TruncateTextPipe,
    FlexLayoutModule,
  ],
})
export class SearchResultCardComponent {
  private readonly searchStore = inject(SearchStore);
  private readonly documentService = inject(DocumentService);

  searchResult = input.required<SearchModel>();
  documentOpened = output<void>();

  searchText = computed(() => this.searchStore.searchText());

  onClick() {
    this.documentService.openDocument({
      contractId: this.searchResult().contractId,
      moduleId: this.searchResult().moduleId,
      workflowId: this.searchResult().workflowId,
      entityInstanceId: this.searchResult().entityInstanceId,
    });

    this.documentOpened.emit();
  }
}
